<template>
  <div class="latest-update-time">
    <div class="inner">
      <img src="@/assets/dashboard/时间.png" />
      <span class="text">最近更新时间：{{date.toLocaleDateString()}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LatestUpdateTime",
  props: {
    date: {
      type: Date
    }
  }
};
</script>

<style lang="scss">
.latest-update-time {
  width: 100%;
  .inner {
    width: 1100px;
    margin: 30px auto 20px auto;

    img {
      width: 20px;
      height: 20px;

      vertical-align: top;
    }

    .text {
      margin: 0 10px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(132, 135, 145, 1);
      line-height: 20px;
      vertical-align: top;
    }
  }
}
</style>